import store2 from "store2";

const { session } = store2;

/**
 * Retrieves affiliate session data from session storage.
 *
 * @typeParam T - The expected shape of the affiliate session data. Defaults to `Record<string, unknown>`.
 * @returns The affiliate session data cast to type `T`, or an empty object of type `T` if not found.
 */
export const getAffiliateSessionData = <T = Record<string, unknown>>(): T => {
  const affiliateSessionData = session.get("affiliate_session", {}) as T;
  return affiliateSessionData || ({} as T);
};

export const storeAffiliateSessionData = <T = Record<string, unknown>>(data: T) => {
  session.set("affiliate_session", data);
};
